/**
 * @file        src/layout/NavBackdrop.jsx
 * @description Mobile backdrop behind the sidebar; tap dismisses the drawer.
 * @author      Kinetika Labs
 * @created     2026-06-22
 * @changelog
 *   - 2026-06-22 Claude — Initial.
 */
import React from 'react';
import { useBooking } from '../store/booking.store.js';

export default function NavBackdrop() {
  const navOpen = useBooking((s) => s.navOpen);
  const closeNav = useBooking((s) => s.closeNav);
  return (
    <div
      id="navBackdrop"
      onClick={closeNav}
      className={
        'lg:hidden fixed inset-0 z-40 bg-night/70 backdrop-blur-sm transition-opacity duration-300 ' +
        (navOpen ? 'opacity-100' : 'opacity-0 pointer-events-none')
      }
    />
  );
}
